<script setup>
import { ref, onMounted } from 'vue';
import feedback1Img from '../../../../assets/images/feedback1.png';
import feedback2Img from '../../../../assets/images/feedback2.png';
import feedback3Img from '../../../../assets/images/feedback3.png';
import feedback4Img from '../../../../assets/images/feedback4.png';
import feedback5Img from '../../../../assets/images/feedback5.png';
import feedback6Img from '../../../../assets/images/feedback6.png';
import feedback7Img from '../../../../assets/images/feedback7.png';
import feedback8Img from '../../../../assets/images/feedback8.png';
import feedback9Img from '../../../../assets/images/feedback9.png';
import feedback10Img from '../../../../assets/images/feedback10.png';
import feedback11Img from '../../../../assets/images/feedback11.png';
import feedback12Img from '../../../../assets/images/feedback12.png';

const feedbackImages = ref([
  feedback1Img,
  feedback2Img,
  feedback3Img,
  feedback4Img,
  feedback5Img,
  feedback6Img,
  feedback7Img,
  feedback8Img,
  feedback9Img,
  feedback10Img,
  feedback11Img,
  feedback12Img,
]);

const leftColumn = ref([]);
const middleColumn = ref([]);
const rightColumn = ref([]);

onMounted(() => {
  // 三列分配：按索引模3分配
  feedbackImages.value.forEach((image, index) => {
    if (index % 3 === 0) {
      leftColumn.value.push({ image, index });
    } else if (index % 3 === 1) {
      middleColumn.value.push({ image, index });
    } else {
      rightColumn.value.push({ image, index });
    }
  });
});
</script>

<template>
  <section class="feedback-section">
    <h2 class="section-title">客戶真實反饋</h2>
    <p class="section-subtitle">成功案例用效果說話</p>
    <div class="feedback-container">
      <div class="feedback-column">
        <div
          v-for="item in leftColumn"
          :key="item.index"
          class="feedback-item"
        >
          <img
            :src="item.image"
            :alt="`客戶反饋 ${item.index + 1}`"
            class="feedback-image"
          />
        </div>
      </div>
      <div class="feedback-column">
        <div
          v-for="item in middleColumn"
          :key="item.index"
          class="feedback-item"
        >
          <img
            :src="item.image"
            :alt="`客戶反饋 ${item.index + 1}`"
            class="feedback-image"
          />
        </div>
      </div>
      <div class="feedback-column">
        <div
          v-for="item in rightColumn"
          :key="item.index"
          class="feedback-item"
        >
          <img
            :src="item.image"
            :alt="`客戶反饋 ${item.index + 1}`"
            class="feedback-image"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.feedback-section {
  width: 100%;
  padding: 20px 40px 10px;
  background: #ffffff;
}

.section-title {
  font-size: 15px;
  color: rgb(29, 32, 35);
  text-align: center;
  margin-bottom: 10px;
}

.section-subtitle {
  font-size: 13px;
  color: rgb(201, 152, 56);
  text-align: center;
  margin-bottom: 20px;
  line-height: 1.6;
}

.feedback-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 5px;
}

.feedback-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.feedback-item {
  width: 100%;
  overflow: hidden;
}

.feedback-image {
  width: 100%;
  height: auto;
  display: block;
}
</style>
